var React = require('react');

function MinusIconDark (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Unsupported"),React.createElement("path",{"d":"M10.5 1H1.5Z","fill":"#90A9A6","key":1}),React.createElement("path",{"d":"M10.5 1H1.5","stroke":"#90A9A6","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

MinusIconDark.defaultProps = {"width":"12","height":"2","viewBox":"0 0 12 2","fill":"none"};

module.exports = MinusIconDark;

MinusIconDark.default = MinusIconDark;
